import React from 'react';
import { Users, FileText, Shield, TrendingUp, Ship } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Services = () => {
  const navigate = useNavigate();
  const services = [
    {
      icon: Users,
      title: 'Buyer Acquisition & Contracting',
      description: 'We identify verified international buyers and negotiate export contracts for Indian exporters.'
    },
    {
      icon: FileText,
      title: 'Exporter Onboarding',
      description: 'We onboard Indian manufacturers and exporters based on product quality and capacity.'
    },
    {
      icon: Shield,
      title: 'Payment Control & Risk Management',
      description: 'Export payments are routed through secure banking channels to ensure safety.'
    },
    {
      icon: TrendingUp,
      title: 'Trade Finance Coordination',
      description: 'We help exporters get pre-shipment and post-shipment finance through banks.'
    },
    {
      icon: Ship,
      title: 'Shipment Execution',
      description: 'We manage export documents, logistics, and delivery to buyers.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Banner */}
      <section className="bg-[#0B2C4D] text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6">What We Do</h1>
          <p className="text-2xl max-w-3xl mx-auto font-semibold text-[#C9A24D]">
            GoldenPort is not a broker.<br />
            We manage complete export transactions.
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto space-y-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-[#C9A24D]"
              >
                <div className="flex items-start gap-6">
                  <div className="bg-[#0B2C4D] p-4 rounded-lg flex-shrink-0">
                    <service.icon className="w-10 h-10 text-[#C9A24D]" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#0B2C4D] mb-3">
                      {index + 1}. {service.title}
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-[#0B2C4D] mb-4">
            Ready to Start Your Export Journey?
          </h2>
          <p className="text-xl text-gray-700 mb-8">
            Let GoldenPort handle all the complexities while you focus on production.
          </p>
          <Button 
            size="lg"
            className="bg-[#C9A24D] hover:bg-[#b8923e] text-[#0B2C4D] font-semibold text-lg px-10 py-6"
            onClick={() => navigate('/contact')}
          >
            Enquiry Now
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;
